import React from "react"
import PropTypes from "prop-types"
import { Modal, Input, Button, Flex } from "antd"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
const AddCategoryModal = ({ visible, onCancel, onAdd, setCategoryName, categoryName }) => {
  const { t } = useTranslation()

  const handleAdd = () => {
    onAdd()
  }

  return (
    <Modal open={visible} onCancel={onCancel} footer={null} centered bodyStyle={{ borderRadius: 16 }} closable={false} width={370}>
      <div>
        <Text variant="heading" fw="500" className="mb-s block" size="lg">
          {t("expense.add_new_category")}
        </Text>
        <Text label fw="500">
          {t("expense.category_name")}*
        </Text>
        <Input
          placeholder="e.g., Ice"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          className="mb-l mt-xs rounded-s"
        />
        <Flex justify="start" gap={12}>
          <Button onClick={onCancel} color="primary" variant="outlined" className="p-5">
            {t("expense.cancel")}
          </Button>
          <Button
            color="primary"
            variant="solid"
            onClick={handleAdd}
            className="p-5"
            disabled={!categoryName.trim()}
          >
            {t("expense.add_category")}
          </Button>
        </Flex>
      </div>
    </Modal>
  )
}

AddCategoryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  setCategoryName: PropTypes.func.isRequired,
  categoryName: PropTypes.string.isRequired,
}

export default AddCategoryModal
